import {
    apiRequest,
    agamaDetail
} from "../../../../../services/adapters/kepegawaian/agamaService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", agamaDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository